import React, { useState } from "react";
import "./Modal.css";

const Modal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    // Initialize form data fields
    name: "",
    email: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission logic
    // Form fields reset after submission
    setFormData({
      name: "",
      email: "",
      message: "",
    });
    // Close the modal after form submission
    setIsOpen(false);
  };

  return (
    <div className="about-modal">
      <button className="open-button" onClick={() => setIsOpen(true)}></button>
      {isOpen && (
        <div className="modal-container">
          <div className="modal-content">
            <p
              style={{
                textAlign: "center",
                textDecorationLine: "underline",
                fontWeight: "bold",
              }}
            >
              Want to be part of a sustainable future?
            </p>
            <p style={{ textAlign: "center" }}>
              Let us know what are your skills and ambitions are and how you
              think that aligns with Your Fair Share's vision. We look forward
              to hearing from you and having you as part of our team!
            </p>
            <p style={{ textAlign: "center" }}>
              You have the opportunity to be part of:
            </p>

            <li>
              <h4>A small team of diverse skill</h4>
            </li>

            <li>
              <h4>
                A pioneering start-up in the field of sustainable business
              </h4>
            </li>

            <li>
              <h4>Potential to take plenty of responsibility</h4>
            </li>

            <span className="close" onClick={() => setIsOpen(false)}>
              &times;
            </span>
            <form onSubmit={handleSubmit}>
              <label>
                <input
                  placeholder="Name"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                <input
                  placeholder="Email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                <textarea
                  placeholder="Message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                />
              </label>
              <button className="submit-button" type="submit"></button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Modal;
